/**
 * Lazy Load CSS Helper
 * Loads stylesheets asynchronously without blocking render
 */
(function() {
  'use strict';
  
  // Polyfill for preload support
  if (!window.loadCSS) {
    window.loadCSS = function(href, before, media) {
      var ss = window.document.createElement("link");
      var ref = before || window.document.getElementsByTagName("script")[0];
      ss.rel = "stylesheet";
      ss.href = href;
      ss.media = media || "all";
      ref.parentNode.insertBefore(ss, ref);
      return ss;
    };
  }
  
  // Load deferred CSS
  var deferredCSS = document.querySelectorAll('link[rel="preload"][as="style"]');
  deferredCSS.forEach(function(link) {
    link.addEventListener('load', function() {
      this.rel = 'stylesheet';
    });
  });
  
  // Lazy load images with Intersection Observer
  if ('IntersectionObserver' in window) {
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
            img.removeAttribute('data-srcset');
          }
          img.classList.remove('lazy-load');
          imageObserver.unobserve(img);
        }
      });
    }, {
      rootMargin: '50px 0px',
      threshold: 0.01
    });
    
    // Observe all lazy images
    document.addEventListener('DOMContentLoaded', function() {
      var lazyImages = document.querySelectorAll('img.lazy-load');
      lazyImages.forEach(function(img) {
        imageObserver.observe(img);
      });
    });
  }
  
  // Preload critical assets
  function preloadAsset(href, as) {
    var link = document.createElement('link');
    link.rel = 'preload';
    link.as = as;
    link.href = href;
    document.head.appendChild(link);
  }
  
  // Defer non-critical JavaScript
  window.addEventListener('load', function() {
    // Load analytics and non-critical scripts after page load
    var deferredScripts = document.querySelectorAll('script[data-defer]');
    deferredScripts.forEach(function(script) {
      var newScript = document.createElement('script');
      newScript.src = script.dataset.src;
      newScript.async = true;
      document.body.appendChild(newScript);
    });
  });
  
})();
